/* AU theme — horizontale rails (UGC + reviews) */
(function () {
  function initRail(rail) {
    var vp = rail.querySelector('[data-au-rail-viewport]');
    if (!vp) return;
    var prev = rail.querySelector('[data-au-rail-prev]');
    var next = rail.querySelector('[data-au-rail-next]');

    function step() {
      var first = vp.querySelector('.au-rail__item');
      if (!first) return vp.clientWidth * 0.8;
      var gap = parseFloat(getComputedStyle(vp).columnGap || getComputedStyle(vp).gap || 16) || 16;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = vp.scrollWidth - vp.clientWidth - 2;
      if (prev) prev.style.opacity = vp.scrollLeft <= 2 ? '0.35' : '1';
      if (next) next.style.opacity = vp.scrollLeft >= max ? '0.35' : '1';
    }

    if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step(), behavior: 'smooth' }); });
    vp.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-au-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  // opnieuw initialiseren als een sectie in de theme-editor herlaadt
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* AU theme — scroll-reveal en tellende cijfers -------------------------- */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var REVEAL = [
    '.au-phero__kicker', '.au-phero__title', '.au-phero__standfirst', '.au-phero__media',
    '.au-prose__lead', '.au-prose__body', '.au-prose__quote', '.au-prose__h',
    '.au-stats__heading', '.au-stats__item', '.au-stats__foot',
    '.au-spec__head', '.au-spec__item',
    '.au-founder__card',
    '.au-promises .au-h2', '.au-promises__item',
    '.au-honesty__head', '.au-honesty__col', '.au-honesty__closing',
    '.au-final__inner > *'
  ].join(',');

  /* Groepen die gestaffeld binnenkomen in plaats van allemaal tegelijk. */
  var STAGGER = ['.au-stats__item', '.au-spec__item', '.au-promises__item', '.au-honesty__col', '.au-final__inner > *'];

  function show(el) { el.classList.add('au-is-in'); }

  function setDelays(root) {
    var scope = root || document;
    STAGGER.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (el) {
        var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.style.transitionDelay = Math.min(idx, 6) * 70 + 'ms';
      });
    });
  }

  /* ---- tellende cijfers ---- */
  function splitValue(el) {
    if (el.dataset.auCountReady) return true;
    var raw = (el.textContent || '').trim();
    var m = raw.match(/^([^0-9]*?)([0-9][0-9.,]*)(.*)$/);
    if (!m) return false;
    var pre = m[1], numStr = m[2], suf = m[3];
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (!isFinite(target)) return false;
    var decimals = (numStr.split('.')[1] || '').length;

    el.textContent = '';
    if (pre) el.appendChild(document.createTextNode(pre));
    var num = document.createElement('span');
    num.className = 'au-stats__num';
    num.textContent = reduce ? numStr : (decimals ? (0).toFixed(decimals) : '0');
    el.appendChild(num);
    if (suf) el.appendChild(document.createTextNode(suf));

    el.dataset.auCountReady = '1';
    el._auTarget = target;
    el._auDecimals = decimals;
    el._auNode = num;
    return true;
  }

  function runCount(el) {
    if (el._auCounted) return;
    el._auCounted = true;
    var node = el._auNode, target = el._auTarget, decimals = el._auDecimals;
    if (!node) return;
    if (reduce) { node.textContent = target.toFixed(decimals); return; }

    var start = null, dur = 1150;
    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 4);            /* easeOutQuart */
      node.textContent = (target * eased).toFixed(decimals);
      if (p < 1) requestAnimationFrame(frame);
      else node.textContent = target.toFixed(decimals);
    }
    requestAnimationFrame(frame);
  }

  function boot(root) {
    var scope = root || document;

    scope.querySelectorAll('.au-stats__value').forEach(splitValue);

    var items = Array.prototype.slice.call(scope.querySelectorAll(REVEAL));
    if (!items.length && !scope.querySelectorAll('.au-stats__value').length) return;

    setDelays(scope);

    if (!('IntersectionObserver' in window)) {
      items.forEach(show);
      scope.querySelectorAll('.au-stats__value').forEach(runCount);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        if (entry.target.matches('.au-stats__item')) {
          var v = entry.target.querySelector('.au-stats__value');
          if (v) runCount(v);
        }
        io.unobserve(entry.target);
      });
    }, {
      /* Vaste offset in pixels, geen percentage: bij een heel hoog venster
         (bijvoorbeeld een screenshot-tool) zou 12% een halve pagina uitsluiten. */
      rootMargin: '0px 0px -60px 0px',
      threshold: 0
    });

    items.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* AU theme — landingspagina: galerij, opties, kleuren, aantal, deadline -- */
(function () {

  /* ---- galerij: thumbnails + volgende-knop ---- */
  function initGallery(root) {
    var tabs = root.querySelectorAll('[data-au-tab]');
    var panels = root.querySelectorAll('[data-au-panel]');
    if (!panels.length) return;
    var current = 0;

    function go(idx) {
      current = (idx + panels.length) % panels.length;
      panels.forEach(function (p) {
        p.classList.toggle('is-active', Number(p.getAttribute('data-au-panel')) === current);
      });
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', Number(t.getAttribute('data-au-tab')) === current);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { go(Number(tab.getAttribute('data-au-tab'))); });
    });
    var next = root.querySelector('[data-au-gal-next]');
    if (next) next.addEventListener('click', function () { go(current + 1); });
  }

  /* ---- aanbod-opties ---- */
  function initOffers(scope) {
    var offers = scope.querySelectorAll('.au-off');
    if (!offers.length) return;
    offers.forEach(function (off) {
      var input = off.querySelector('.au-off__input');
      if (!input) return;
      input.addEventListener('change', function () {
        offers.forEach(function (o) { o.classList.remove('is-selected'); });
        off.classList.add('is-selected');
      });
    });
  }

  /* ---- kleurkaarten ----
     Koppelt aan een echte variant zodra er een product hangt: we zoeken de
     variant waarvan de titel de kleurnaam bevat. Lukt dat niet, dan blijft
     de keuze puur visueel. */
  function initColours(scope) {
    var cards = scope.querySelectorAll('[data-au-colour]');
    if (!cards.length) return;
    var variantInput = scope.querySelector('[data-au-variant-input]');
    var variants = window.auVariants || null;

    function apply(btn) {
      cards.forEach(function (c) {
        var on = c === btn;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var name = (btn.getAttribute('data-au-colour') || '').toLowerCase();
      if (variantInput && variants) {
        for (var i = 0; i < variants.length; i++) {
          if ((variants[i].title || '').toLowerCase().indexOf(name) !== -1) {
            variantInput.value = variants[i].id;
            break;
          }
        }
      }
    }

    cards.forEach(function (btn) { btn.addEventListener('click', function () { apply(btn); }); });
    apply(scope.querySelector('.au-col.is-active') || cards[0]);
  }

  /* ---- aantal ---- */
  function initQty(scope) {
    scope.querySelectorAll('[data-au-qty]').forEach(function (box) {
      var input = box.querySelector('.au-qty__input');
      if (!input) return;
      function step(d) {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        input.value = Math.max(1, v + d);
      }
      var up = box.querySelector('[data-au-qty-up]');
      var down = box.querySelector('[data-au-qty-down]');
      if (up) up.addEventListener('click', function () { step(1); });
      if (down) down.addEventListener('click', function () { step(-1); });
    });
  }

  /* ---- eerlijke countdown ----
     Telt af naar één vaste datum. Is die verstreken, dan verdwijnt de klok
     in plaats van opnieuw te beginnen. */
  function initDeadline(scope) {
    scope.querySelectorAll('[data-au-deadline]').forEach(function (bar) {
      var end = Date.parse(bar.getAttribute('data-au-deadline'));
      var clock = bar.querySelector('[data-au-clock]');
      if (!clock || isNaN(end)) return;
      var dEl = bar.querySelector('[data-au-clock-d]');
      var hEl = bar.querySelector('[data-au-clock-h]');
      var mEl = bar.querySelector('[data-au-clock-m]');
      var sEl = bar.querySelector('[data-au-clock-s]');

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var left = end - Date.now();
        if (left <= 0) { clock.style.display = 'none'; return; }
        clock.style.display = '';
        var t = Math.floor(left / 1000);
        /* met een dagenvak tellen de uren tot 24, zonder lopen ze door */
        if (dEl) {
          dEl.textContent = pad(Math.floor(t / 86400));
          if (hEl) hEl.textContent = pad(Math.floor((t % 86400) / 3600));
        } else if (hEl) {
          hEl.textContent = pad(Math.floor(t / 3600));
        }
        if (mEl) mEl.textContent = pad(Math.floor((t % 3600) / 60));
        if (sEl) sEl.textContent = pad(t % 60);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  function boot(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-au-gallery]').forEach(initGallery);
    initOffers(scope);
    initColours(scope);
    initQty(scope);
    initDeadline(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* AU theme — wisselende aankondigingsbalk ------------------------------- */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRotator(box) {
    var lines = box.querySelectorAll('.au-announce__line');
    if (lines.length < 2) return;
    var ms = parseInt(box.getAttribute('data-au-rotate-ms'), 10);
    if (!ms || ms < 1500) ms = 4000;
    var i = 0;
    var timer = null;

    function step() {
      lines[i].classList.remove('is-active');
      i = (i + 1) % lines.length;
      lines[i].classList.add('is-active');
    }
    function start() { if (!timer) timer = setInterval(step, ms); }
    function stop() { clearInterval(timer); timer = null; }

    /* niet doorlopen als het tabblad niet zichtbaar is */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);

    if (!reduce) start();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-au-rotate]').forEach(initRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* AU theme — productpagina: variantkiezer en meelopende koopbalk -------- */
(function () {
  function initProduct(root) {
    if (root.dataset.auProductReady) return;
    root.dataset.auProductReady = '1';

    var dataEl = root.querySelector('[data-au-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-au-variant-id]');
    var radios = root.querySelectorAll('[data-au-option]');
    var addButtons = root.querySelectorAll('[data-au-add]');

    function selected() {
      var opts = [];
      radios.forEach(function (r) {
        if (r.checked) opts[Number(r.getAttribute('data-au-option')) - 1] = r.value;
      });
      return opts;
    }

    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (variants[i].options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      var thumb = root.querySelector('.au-gal__thumb[data-media-id="' + mediaId + '"]');
      if (thumb) thumb.click();
    }

    function render(variant) {
      addButtons.forEach(function (btn) {
        var ok = !!(variant && variant.available);
        btn.disabled = !ok;
        btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-sold-out');
      });
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-au-price]').forEach(function (el) { el.innerHTML = variant.price; });
      root.querySelectorAll('[data-au-compare]').forEach(function (el) {
        el.hidden = !variant.compare;
        if (variant.compare) el.innerHTML = variant.compare;
      });
      root.querySelectorAll('[data-au-save]').forEach(function (el) {
        el.hidden = !variant.save;
        var pct = el.querySelector('[data-au-save-pct]');
        if (pct) pct.textContent = variant.save;
      });
    }

    function onChange() {
      var opts = selected();
      opts.forEach(function (value, idx) {
        var label = root.querySelector('[data-au-option-current="' + (idx + 1) + '"]');
        if (label) label.textContent = value;
      });
      var variant = find(opts);
      render(variant);
      if (variant) {
        showMedia(variant.media);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', onChange); });

    /* ---- meelopende koopbalk: verschijnt zodra de echte knop uit beeld is ---- */
    var sticky = root.querySelector('[data-au-sticky]');
    var mainAdd = root.querySelector('.au-pdp__form [data-au-add]');
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('button');
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        /* alleen tonen als de knop bóven het venster is verdwenen */
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      });
      io.observe(mainAdd);
    }
  }

  function boot(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-au-product]')) initProduct(scope);
    scope.querySelectorAll('[data-au-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

/* UpCart: huisstijl, Engelse teksten en filter-aanbod in de cart drawer.
   UpCart rendert in een shadow root; teksten uit de app (nu Spaans) worden hier vertaald,
   en bij elke nieuwe weergave opnieuw toegepast. */
(function () {
  var src = document.querySelector('link[data-au-upcart-src]');
  if (!src) return;

  var TEXT = [
    [/^\s*Finalizar compra/i, 'Checkout'],
    [/^\s*Pagar/i, 'Checkout'],
    [/^\(?\s*Ahorra\s+(.+?)\)?\s*$/i, 'Save $1'],
    [/^\s*Descuentos?\s*$/i, 'Discount'],
    [/^\s*Subtotal\s*$/i, 'Subtotal'],
    [/^\s*Env[ií]o\s*$/i, 'Shipping'],
    [/^\s*Gratis\s*$/i, 'Free'],
    [/^\s*Tu carrito est[aá] vac[ií]o\.?\s*$/i, 'Your cart is empty'],
    [/^\s*Seguir comprando\s*$/i, 'Continue shopping'],
    [/^\s*Comprar ahora\s*$/i, 'Shop now'],
    [/^\s*A[nñ]adir( al carrito)?\s*$/i, 'Add'],
    [/^\s*C[oó]digo de descuento\s*$/i, 'Discount code'],
    [/^\s*Aplicar\s*$/i, 'Apply'],
    [/^\s*Eliminar\s*$/i, 'Remove'],
    [/^\s*Tambi[eé]n te puede gustar\s*$/i, 'You may also like'],
    [/^\s*¡?Tus productos est[aá]n reservados por\s*$/i, 'Your cart is reserved for '],
    [/^\s*!\s*$/, '']
  ];
  var FILTER = { handle: 'replacement-filter', handheld: 63898024771914, rain: 63898024837450 };
  var filterProduct = null;

  function translate(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue;
      if (!t || !t.trim()) continue;
      for (var i = 0; i < TEXT.length; i++) {
        if (TEXT[i][0].test(t)) { node.nodeValue = t.replace(TEXT[i][0], TEXT[i][1]); break; }
      }
    }
    var checkout = root.querySelector('.upcart-checkout-button-container a');
    if (checkout && /Finalizar|Pagar/i.test(checkout.textContent)) {
      checkout.textContent = checkout.textContent.replace(/Finalizar compra|Pagar/i, 'Checkout');
    }
  }

  function money(cents) {
    var cur = (window.__auUcCart && window.__auUcCart.currency) || 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function renderOffer(root) {
    var body = root.querySelector('.upcart-cart-body');
    var items = root.querySelectorAll('.upcart-public-cart-item');
    var old = root.querySelector('.au-uc-offer');
    var cart = window.__auUcCart;
    if (!body || !items.length || !cart || !filterProduct) { if (old) old.remove(); return; }
    var handles = cart.items.map(function (it) { return it.handle; });
    if (handles.indexOf(FILTER.handle) !== -1) { if (old) old.remove(); return; }
    var fits = handles.indexOf('rain-filter-shower-head') !== -1 && handles.indexOf('handheld-filter-shower') === -1 ? 'rain' : 'handheld';
    if (handles.indexOf('rain-filter-shower-head') === -1 && handles.indexOf('handheld-filter-shower') === -1) { if (old) old.remove(); return; }
    var variant = filterProduct.variants.filter(function (v) { return v.id === FILTER[fits]; })[0];
    if (!variant) return;
    if (old && old.getAttribute('data-variant') === String(variant.id)) return;
    if (old) old.remove();
    var img = (filterProduct.images && filterProduct.images[1]) || filterProduct.featured_image || '';
    var box = document.createElement('div');
    box.className = 'au-uc-offer';
    box.setAttribute('data-variant', variant.id);
    box.innerHTML =
      '<p class="au-uc-offer__kicker">Complete your setup</p>' +
      '<div class="au-uc-offer__card">' +
        (img ? '<img class="au-uc-offer__img" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '') +
        '<div class="au-uc-offer__text">' +
          '<p class="au-uc-offer__title">3 replacement filters</p>' +
          '<p class="au-uc-offer__sub">Fresh filter for 9 months</p>' +
          '<p class="au-uc-offer__price"><strong>' + money(variant.price) + '</strong>' +
            (variant.compare_at_price > variant.price ? ' <s>' + money(variant.compare_at_price) + '</s>' : '') + '</p>' +
        '</div>' +
        '<button type="button" class="au-uc-offer__add">Add</button>' +
      '</div>';
    box.querySelector('button').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      btn.disabled = true; btn.textContent = '...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) })
        .then(function () { return window.upcartRefreshCart && window.upcartRefreshCart(); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add'; });
    });
    var anchor = root.querySelector('[class*="CartPreview__bottomModules"]');
    if (anchor) anchor.parentNode.insertBefore(box, anchor); else body.appendChild(box);
  }

  var SHOP_HANDLES = ['handheld-filter-shower', 'rain-filter-shower-head'];
  var shopProducts = null;
  function loadShopProducts() {
    if (shopProducts) return Promise.resolve(shopProducts);
    return Promise.all(SHOP_HANDLES.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) { shopProducts = list.filter(Boolean); return shopProducts; });
  }

  function renderEmpty(root) {
    var empty = root.querySelector('[class*="CartPreview__empty__"]:not([class*="empty__body"])');
    if (!empty || empty.querySelector('.au-uc-empty')) return;
    var box = document.createElement('div');
    box.className = 'au-uc-empty';
    box.innerHTML =
      '<span class="au-uc-empty__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>' +
      '</span>' +
      '<p class="au-uc-empty__title">Your cart is empty</p>' +
      '<p class="au-uc-empty__text">Softer skin and hair start with better water. Pick your shower to get started.</p>' +
      '<div class="au-uc-empty__cards"></div>' +
      '<p class="au-uc-empty__trust">✓ Free shipping   ✓ 30 day guarantee</p>';
    empty.appendChild(box);
    loadShopProducts().then(function (list) {
      var wrap = box.querySelector('.au-uc-empty__cards');
      list.forEach(function (p) {
        var v = p.variants[0];
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        var a = document.createElement('a');
        a.className = 'au-uc-empty__card';
        a.href = '/products/' + p.handle;
        a.innerHTML =
          (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
          '<span class="au-uc-empty__cardtext"><span class="au-uc-empty__cardtitle">' + p.title + '</span>' +
          '<span class="au-uc-empty__cardprice">' + money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '') + '</span></span>' +
          '<span class="au-uc-empty__go" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>';
        wrap.appendChild(a);
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { window.__auUcCart = c; });
  }

  function setup(root) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = src.href;
    link.setAttribute('data-au-upcart', '');
    root.appendChild(link);

    var busy = false;
    function apply() {
      if (busy) return;
      busy = true;
      translate(root);
      renderOffer(root);
      renderEmpty(root);
      busy = false;
    }
    // Vertalen meteen in de observer (loopt voor de volgende schermopbouw), zodat de
    // afteller die elke seconde opnieuw rendert nooit even Spaans laat zien.
    new MutationObserver(function () {
      translate(root);
      clearTimeout(apply.t);
      apply.t = setTimeout(apply, 30);
    }).observe(root, { childList: true, subtree: true, characterData: true });

    fetch('/products/' + FILTER.handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { filterProduct = p; return refreshCart(); }).then(apply).catch(function () {});
    ['upcartSubscribeCartUpdated', 'upcartSubscribeCartLoaded', 'upcartSubscribeAddedToCart', 'upcartSubscribeCartOpened'].forEach(function (fn) {
      if (typeof window[fn] === 'function') {
        try { window[fn](function () { refreshCart().then(apply); }); } catch (e) {}
      }
    });
    apply();
  }

  var tries = 0;
  var timer = setInterval(function () {
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot) { clearInterval(timer); if (!host.shadowRoot.querySelector('link[data-au-upcart]')) setup(host.shadowRoot); }
    else if (++tries > 80) clearInterval(timer);
  }, 250);
})();

/* Trackingpagina: klanten mogen alleen het getal van hun ordernummer intypen.
   "1046", "#1046" en "im1046" worden "#IM1046" (voorvoegsel uit data-order-prefix). */
(function () {
  var intro = document.querySelector('.au-track__intro[data-order-prefix]');
  if (!intro) return;
  var prefix = (intro.getAttribute('data-order-prefix') || '').toUpperCase();
  function fix(input) {
    if (!input) return;
    var raw = (input.value || '').trim();
    var digits = raw.replace(/^#/, '').replace(new RegExp('^' + prefix, 'i'), '').trim();
    if (!/^\d+$/.test(digits)) return;
    var val = '#' + prefix + digits;
    if (input.value === val) return;
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, val);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function orderInputs(scope) {
    return (scope || document).querySelectorAll('.pp_tracking_form_order form .pp_tracking_parent:first-child input');
  }
  function fixAll(scope) { Array.prototype.forEach.call(orderInputs(scope), fix); }
  // vóór ParcelPanel de knop of Enter afhandelt
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pp-button-enter');
    if (btn) fixAll(btn.closest('form'));
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.pp_tracking_form')) fixAll(e.target.closest('form'));
  }, true);
  document.addEventListener('focusout', function (e) {
    if (e.target.matches && e.target.matches('.pp_tracking_form_order input')) {
      var first = e.target.closest('.pp_tracking_parent');
      if (first && first.parentElement && first === first.parentElement.querySelector('.pp_tracking_parent')) fix(e.target);
    }
  }, true);
})();

